import { render, staticRenderFns } from "./privacyModal.vue?vue&type=template&id=b24d6356&name=privacyModal&"
import script from "./privacyModal.vue?vue&type=script&lang=js&"
export * from "./privacyModal.vue?vue&type=script&lang=js&"
import style0 from "./privacyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports